import Repository from "./Repository";
import type {PeriodeMetOpdrachten} from "../../types/opdrachten/PeriodeMetOpdrachten";
import type {PeriodeMetOnderbrekingen} from "../../types/opdrachten/PeriodeMetOnderbrekingen";

const baseUrl = `opdrachten`;

export default {
  async getPeriodesMetOpdrachten(): Promise<PeriodeMetOpdrachten[]> {
    const response = await Repository.post<PeriodeMetOpdrachten[]>(`${baseUrl}/opdrachtPeriodes`);
    return response.data;
  },

  async getPeriodesMetOnderbrekingen(): Promise<PeriodeMetOnderbrekingen[]> {
    const response = await Repository.post<PeriodeMetOnderbrekingen[]>(`${baseUrl}/onderbrekingPeriodes`);
    return response.data;
  },

  async moduleSettings(): Promise<ModuleSettings> {
    const response = await Repository.post<ModuleSettings>(`${baseUrl}/moduleSettings`);
    return response.data;
  },
};

export interface ModuleSettings { 
  readonly volumeTewerkstelling?: string;
}
